var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.662,
    height: 26.662,
    viewBox: "0 0 26.662 26.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dollar-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14693",
    "data-name": "Path 14693",
    d: "M11.75,7.847a2.489,2.489,0,0,0-2,2.2,2.489,2.489,0,0,0,2,2.2Z",
    transform: "translate(2.582 1.948)",
    fill: "#ff7070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14694",
    "data-name": "Path 14694",
    d: "M12.75,12.847v4.406a2.489,2.489,0,0,0,2-2.2A2.489,2.489,0,0,0,12.75,12.847Z",
    transform: "translate(3.581 3.613)",
    fill: "#ff7070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14695",
    "data-name": "Path 14695",
    d: "M28.662,15.331A13.331,13.331,0,1,1,15.331,2,13.331,13.331,0,0,1,28.662,15.331Zm-13.331-9a1,1,0,0,1,1,1v.422a4.524,4.524,0,0,1,4,4.244,1,1,0,0,1-2,0,2.489,2.489,0,0,0-2-2.2V14.42a4.524,4.524,0,0,1,4,4.244,4.524,4.524,0,0,1-4,4.244v.422a1,1,0,1,1-2,0v-.422a4.524,4.524,0,0,1-4-4.244,1,1,0,0,1,2,0,2.489,2.489,0,0,0,2,2.2V16.242a4.524,4.524,0,0,1-4-4.244,4.524,4.524,0,0,1,4-4.244V7.332A1,1,0,0,1,15.331,6.333Z",
    fill: "#ff7070",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.1d922fecbef23c1bc6dcc39f37e1cbd3.svg";
export { ForwardRef as ReactComponent };